import { Component, OnInit,Input,Output,EventEmitter } from '@angular/core';
import { GridBaseCase } from '../grid/grid.base.case';
@Component({
  selector: 'app-maps',
  templateUrl: './maps.component.html',
  styleUrls: ['./maps.component.scss']
})
export class MapsComponent extends GridBaseCase implements OnInit {
  @Input() data: any;//接收父组件的值
  @Output() private childOuter = new EventEmitter();
  constructor() {super();}

  ngOnInit() {
  }
  getCoordInate(elem){
    this.childOuter.emit(elem);
console.log(elem);
  }
  ngOnChanges(){
    console.log("传值结果:"+this.data);
    
    }
}
